import React, { ReactNode } from "react";
import { IPlanRecurrency } from "~/types/types";
import mediaQueries from "~/components/mediaQueries";
import * as palette from "@govlaunch/palette";
import ChangePlanOptionName from "~/components/makers/ChangePlanOptionName";
import ChangePlanOptionDescription from "~/components/makers/ChangePlanOptionDescription";
import ChangePlanOptionPrice from "~/components/makers/ChangePlanOptionPrice";

interface IPlanProps {
  name: string;
  description: ReactNode;
  price: number;
  recurrency?: IPlanRecurrency;
  isSelected: boolean;
  viewerIsSubscribed: boolean;
  onSelect: () => void;
}

export default function ChangePlanOption({
  name,
  description,
  price,
  recurrency,
  isSelected,
  viewerIsSubscribed,
  onSelect,
}: IPlanProps) {
  return (
    <div
      role="button"
      onClick={() => {
        if (!viewerIsSubscribed || (viewerIsSubscribed && !isSelected)) {
          onSelect();
        }
      }}
      css={mediaQueries({
        display: "grid",
        gridTemplateColumns: ["1fr", "1fr", "1fr", "150px 1fr 150px"],
        alignItems: "center",
        minHeight: 120,
        backgroundColor: palette.white,
        border: isSelected ? `solid 2px ${palette.innovatorBlue}` : "solid 2px #e3e3e3",
        borderRadius: 4,
        "&:hover": {
          border: `solid 2px ${palette.innovatorBlue}`,
          cursor: "pointer",
        },
      })}
    >
      <ChangePlanOptionName name={name} viewerIsSubscribed={viewerIsSubscribed} />

      <ChangePlanOptionDescription description={description} />

      <ChangePlanOptionPrice price={price} recurrency={recurrency} name={name} />
    </div>
  );
}
